export const PRODUCTION_ANALYTICS_API_URL = 'https://analytics-api.hapttic.com'
export const PRODUCTION_SUGGESTIONS_API_URL =
  'https://suggestions-api.hapttic.com'
export const AUTH_API_URL = 'https://n1.noxtton.com'
// Local sm.back runs on port 3001. Dev (`yarn start`) targets it by default so
// backend changes are exercised end-to-end; builds always hit production.
//
// To point dev at the deployed API instead, set REACT_APP_ANALYTICS_API_URL in
// `.env.local` (gitignored, so it stays machine-local and doesn't force the
// choice on anyone running a local backend):
//   REACT_APP_ANALYTICS_API_URL=https://analytics-api.hapttic.com
// Restart `yarn start` after changing it — CRA only reads env at boot.
export const DEV_ANALYTICS_API_URL = 'http://localhost:3001'
export const ANALYTICS_API_URL =
  process.env.REACT_APP_ANALYTICS_API_URL ||
  (process.env.NODE_ENV === 'development'
    ? DEV_ANALYTICS_API_URL
    : PRODUCTION_ANALYTICS_API_URL)
// Inbox Backend URL (Facebook OAuth and page management)
export const INBOX_BACKEND_URL = 'https://hapttic-inbox.website'
